import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/common.model';

export interface PaymentMethodConfig {
  id: string;
  name: string;
  isActive: boolean;
  accountLink: string | null;
  displayOrder: number;
}

export interface UpdatePaymentMethodRequest {
  isActive: boolean;
  accountLink: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private apiUrl = `${environment.apiUrl}/settings`;

  constructor(private http: HttpClient) {}

  getPaymentMethods(): Observable<ApiResponse<PaymentMethodConfig[]>> {
    return this.http.get<ApiResponse<PaymentMethodConfig[]>>(`${this.apiUrl}/payment-methods`);
  }

  updatePaymentMethod(id: string, request: UpdatePaymentMethodRequest): Observable<ApiResponse<null>> {
    return this.http.put<ApiResponse<null>>(`${this.apiUrl}/payment-methods/${id}`, request);
  }
}
